import { Box, Stack, Typography } from '@mui/material';

import { language } from '@/ui/i18n';
import { Fonts } from '@/ui/theme/fonts';
import { ScoreColor } from '@/ui/utils/get-color-for-score';

export type ScoreBarPosition = 'higher' | 'normal' | 'lower';
export type ScoreBarDirection = 'horizontal' | 'vertical';

export function VerticalScoreBar({
  value,
  colors,
  position,
}: {
  value: number;
  colors: ScoreColor;
  position: ScoreBarPosition;
}) {
  const getHeight = (): string | number => {
    switch (position) {
      case 'higher':
        return 130;
      case 'normal':
        return 115;
      case 'lower':
        return 100;
    }
  };

  return (
    <Box
      position={'relative'}
      height={getHeight()}
      width={'fit-content'}
      bgcolor={colors.secondary}
      minWidth={50}
      borderRadius={2}
    >
      <Stack
        sx={{
          backgroundColor: colors.main,
          height: 50,
          width: 'fit-content',
          minWidth: 50,
          paddingX: 1,
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: '1.75rem',
            fontWeight: '900',
            fontFamily: Fonts.DarkerGrotesque,
            color: colors.text,
          }}
        >
          {value ? value.toLocaleString(language) : '-'}
        </Typography>
      </Stack>
    </Box>
  );
}
